import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import profileImage from "@/components/profileImage.vue";
let widget = class widget extends Vue {
    get selected() {
        return (this.profileIds.find((v) => this.profile.id == v) !== undefined);
    }
    click(e) {
        if (!this.selected)
            this.addProfileId(this.profile.id);
        else
            this.removeProfileId(this.profile.id);
        e.stopPropagation();
    }
};
tslib_1.__decorate([
    Prop({ required: true })
], widget.prototype, "profile", void 0);
tslib_1.__decorate([
    Prop({ required: true })
], widget.prototype, "showAllSelected", void 0);
tslib_1.__decorate([
    Getter("config/profileIds")
], widget.prototype, "profileIds", void 0);
tslib_1.__decorate([
    Action("config/addProfileId")
], widget.prototype, "addProfileId", void 0);
tslib_1.__decorate([
    Action("config/removeProfileId")
], widget.prototype, "removeProfileId", void 0);
widget = tslib_1.__decorate([
    Component({
        components: {
            profileImage
        }
    })
], widget);
export default widget;
